/*
 * Die Typen, unter denen im Editor gezogen wird.
 *
 * Eine eigene Datei fuer eine einzige Konstante, und der Grund ist die
 * Richtung: die Palette schreibt sie, die Rasterflaeche liest sie, und keine
 * von beiden soll die andere kennen muessen. Stuende der String in einer der
 * zwei Dateien, haenge die andere daran, oder, was am Anfang tatsaechlich
 * passiert ist, es gaebe ihn zweimal.
 *
 * Zwei Konstanten mit demselben Wert sind genau die Sorte Zwilling, von der
 * eines Tages einer geaendert wird. Der Schaden waere wortlos: die Palette
 * schriebe einen Typ, den die Flaeche nicht prueft, der Browser zeigte beim
 * Ablegen "verboten" und niemand sagte warum.
 */

/**
 * Art des Widgets beim Ziehen aus der Palette.
 *
 * Eigener Typ und nicht `text/plain`: die Flaeche nimmt genau diesen entgegen
 * und weist alles andere ab. Ein aus dem Browser hereingezogener Text oder
 * eine Datei sollen nicht versehentlich ein Widget erzeugen. Dasselbe Muster
 * benutzt der Datenpunktbaum in `pages/PlantSchemaPage.tsx`, dort heisst der
 * Typ `application/x-hvacloud-schema`.
 */
export const WIDGET_KIND_DRAG_TYPE = 'application/x-hvacloud-widget-kind';
